import {types} from "mobx-state-tree";


export default types.model('TagBusinessLookUpModel', {
  tagId: types.optional(types.identifierNumber, 0),
  tagName: types.maybeNull(types.string)
})